import { ModalController } from 'react-modal-global';

const Global = new ModalController();
export default Global;
